module.exports = __webpack_public_path__ + "img/9.70c240f6.png";